import styled from "styled-components";

export const StandardToastImageBox = styled.div`
   color: ${({theme}) => theme.colors.brandPrimary};
   max-width: 10rem;
   max-height: 10rem;
   margin-right: 4px;
`;
